// extracted by mini-css-extract-plugin
export default {"importing":"ImportStatus_importing__RK7i+","spin":"ImportStatus_spin__3M7fD"};